var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_task_group_create",
          attrs: {
            id: "modal-task-group-create",
            title: "Новая группа заявок",
            size: "xl",
            "hide-header-close": "",
            "content-class": "modal-fullscreen",
            "body-class": "modal-body-fullscreen",
            "modal-class": "custom-modal",
            lazy: "",
            centered: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: { hidden: _vm.onHidden },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _vm.newItem.task_workers.length !== 0 &&
                      _vm.tabIndex === 1
                        ? _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-secondary mr-2",
                              on: { click: _vm.handleHelpToggle }
                            },
                            [
                              _c("v-icon", {
                                attrs: {
                                  name: "buttons/question_circle",
                                  size: 16
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          on: { click: _vm.hideModal }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _vm.tabIndex < 2
                        ? _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-primary",
                              on: { click: _vm.nextStep }
                            },
                            [_vm._v("\n          Далее\n        ")]
                          )
                        : _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-primary",
                              on: { click: _vm.handleSubmit }
                            },
                            [_vm._v("\n          Сохранить\n        ")]
                          )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "b-tabs",
            {
              staticClass: "custom-tabs stepper-vertical",
              attrs: { vertical: "" },
              model: {
                value: _vm.tabIndex,
                callback: function($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex"
              }
            },
            [
              _c(
                "b-tab",
                {
                  attrs: { active: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "step-item",
                              class: { "is-completed": _vm.isStep1Complete }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "step-icon",
                                  class: { "is-completed": _vm.isStep1Complete }
                                },
                                [
                                  _vm.isStep1Complete
                                    ? _c("v-icon", {
                                        attrs: {
                                          name: "buttons/check",
                                          size: 12
                                        }
                                      })
                                    : _c("span", [_vm._v("1")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "step-label" }, [
                                _c("span", { staticClass: "step-title" }, [
                                  _vm._v("Информация")
                                ])
                              ])
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mb-4" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: { id: "group-location", label: "Объект" }
                            },
                            [
                              _c("location-select", {
                                ref: "location_select",
                                attrs: {
                                  id: "input-location-select",
                                  value: _vm.newItem.location_id,
                                  state: _vm.validationState.location_id
                                },
                                on: { onSelect: _vm.onLocationChange }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "group-start-address",
                                label: _vm.$t(
                                  "message.tasks.modal.start_address"
                                )
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input_start_address",
                                  type: "text",
                                  state: _vm.validationState.start_address,
                                  placeholder: _vm.$t(
                                    "message.tasks.modal.start_addressPlaceholder"
                                  )
                                },
                                model: {
                                  value: _vm.newItem.start_address,
                                  callback: function($$v) {
                                    _vm.$set(_vm.newItem, "start_address", $$v)
                                  },
                                  expression: "newItem.start_address"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mb-4" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: { id: "group-executor", label: "Менеджер" }
                            },
                            [
                              _c("user-select", {
                                ref: "user_select",
                                staticClass: "mr-2 flex-fill",
                                attrs: {
                                  id: "input-user-select",
                                  state: _vm.validationState.executor,
                                  value: _vm.newItem.executor,
                                  "is-disabled":
                                    _vm.newItem.location_id === 0 ||
                                    _vm.noLocationDisabled
                                },
                                on: { onSelect: _vm.onSelectExecutor }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "group-project",
                                label: "Руководитель"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-project",
                                  readonly: "",
                                  value: _vm.newItem.project_name || "-"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mb-4" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "8" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "group-work-type",
                                label: "Вид работ объекта"
                              }
                            },
                            [
                              _c("location-works-select", {
                                ref: "location_works_select",
                                attrs: {
                                  id: "location-works-select",
                                  state:
                                    _vm.validationState.task_location_works,
                                  "is-disabled":
                                    _vm.newItem.location_id === 0 ||
                                    _vm.noLocationDisabled
                                },
                                on: { onSelect: _vm.onLocationWorkSelect }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "4" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "group-workers-count",
                                label: "Количество исполнителей"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-workers-count",
                                  type: "number",
                                  min: "0",
                                  state: _vm.validationState.plan_workers_count
                                },
                                model: {
                                  value: _vm.newItem.plan_workers_count,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newItem,
                                      "plan_workers_count",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "newItem.plan_workers_count"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mb-4" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: { id: "group-workers" },
                              scopedSlots: _vm._u([
                                {
                                  key: "label",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center"
                                        },
                                        [
                                          _c("span", [_vm._v("Исполнители")]),
                                          _vm._v(" "),
                                          _vm.newItem.task_workers.length
                                            ? _c(
                                                "b-badge",
                                                {
                                                  staticClass:
                                                    "ml-2 mt-1 task-group-badge"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.newItem.task_workers
                                                          .length
                                                      ) +
                                                      " чел.\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ])
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "form-control custom-tags-input position-relative d-flex"
                                },
                                [
                                  _vm.newItem.task_workers.length
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tags-wrapper d-flex flex-wrap align-items-center"
                                        },
                                        _vm._l(
                                          _vm.newItem.task_workers,
                                          function(worker) {
                                            return _c(
                                              "span",
                                              {
                                                key: worker.id,
                                                class: [
                                                  "custom-tag",
                                                  _vm.getLevelEfficiencyStyle(
                                                    worker.level_efficiency
                                                  )
                                                ]
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-truncate",
                                                    staticStyle: {
                                                      "max-width": "180px"
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(worker.name))]
                                                ),
                                                _vm._v(" "),
                                                _c("v-icon", {
                                                  staticClass:
                                                    "cursor-pointer ml-2",
                                                  attrs: {
                                                    name: "buttons/cross",
                                                    size: 8
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.removeWorker(
                                                        worker.worker_id
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _c("div", { staticClass: "text-muted" }, [
                                        _vm._v(
                                          "\n                  Исполнители не выбраны\n                "
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _vm.newItem.task_workers.length
                                    ? _c("v-icon", {
                                        staticClass: "clear-all-icon",
                                        attrs: {
                                          name: "buttons/cross",
                                          size: 12
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.clearAllWorkers.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "custom-btn-dashed mt-2",
                                  attrs: { type: "button" },
                                  on: { click: _vm.showWorkersSelect }
                                },
                                [
                                  _c("v-icon", {
                                    attrs: { name: "buttons/plus", size: 11 }
                                  }),
                                  _vm._v(
                                    "\n                Добавить исполнителей\n              "
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "step-item",
                              class: { "is-completed": _vm.isStep2Complete }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "step-icon",
                                  class: { "is-completed": _vm.isStep2Complete }
                                },
                                [
                                  _vm.isStep2Complete
                                    ? _c("v-icon", {
                                        attrs: {
                                          name: "buttons/check",
                                          size: 12
                                        }
                                      })
                                    : _c("span", [_vm._v("2")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "step-label" }, [
                                _vm.newItem.task_workers.length !== 0
                                  ? _c("span", { staticClass: "step-title" }, [
                                      _vm._v("Табель")
                                    ])
                                  : _c("span", { staticClass: "step-title" }, [
                                      _vm._v("Календарь")
                                    ])
                              ])
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "w-100 d-flex flex-column flex-grow-1",
                      staticStyle: { "min-height": "0" }
                    },
                    [
                      _vm.newItem.task_workers.length !== 0
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex flex-column flex-grow-1",
                              staticStyle: { "min-height": "0" }
                            },
                            [
                              _c("task-timesheet", {
                                ref: "timesheet",
                                staticClass: "flex-grow-1",
                                attrs: {
                                  "base-task": _vm.newItem,
                                  services: _vm.locationWorkServices,
                                  "scroll-locked": _vm.onboardingStep > 0
                                },
                                on: {
                                  change: _vm.updateTimesheetTasks,
                                  "workers-planned": function($event) {
                                    _vm.plannedWorkersCount = $event
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "d-flex flex-column flex-grow-1",
                              staticStyle: { "min-height": "0" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex align-items-center mb-3"
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentMonth,
                                          expression: "currentMonth"
                                        }
                                      ],
                                      staticClass: "custom-select-filters mr-2",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.currentMonth = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    _vm._l(_vm.availableMonths, function(
                                      month
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: month.index,
                                          domProps: { value: month.index }
                                        },
                                        [_vm._v(_vm._s(month.name))]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentYear,
                                          expression: "currentYear"
                                        }
                                      ],
                                      staticClass: "custom-select-filters",
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.currentYear = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    _vm._l(_vm.availableYears, function(year) {
                                      return _c(
                                        "option",
                                        {
                                          key: year,
                                          domProps: { value: year }
                                        },
                                        [_vm._v(_vm._s(year))]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "calendar-grid header" },
                                _vm._l(_vm.weekDays, function(day) {
                                  return _c(
                                    "div",
                                    { key: day, staticClass: "weekday-cell" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(day) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "calendar-grid" },
                                _vm._l(_vm.calendarDays, function(day, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: day.dateString,
                                      staticClass: "date-cell",
                                      class: {
                                        "is-not-current-month": !day.isCurrentMonth,
                                        "is-selected": _vm.isDateSelected(
                                          day.dateString
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleDate(day.dateString)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "day-number" },
                                        [_vm._v(_vm._s(day.dayNumber))]
                                      ),
                                      _vm._v(" "),
                                      day.dayNumber === 1 || index === 0
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "month-label text-truncate"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.getMonthNameByDate(
                                                      day.date
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c("div", { staticClass: "step-item" }, [
                            _c("div", { staticClass: "step-icon" }, [
                              _vm._v("3")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "step-label" }, [
                              _c("span", { staticClass: "step-title" }, [
                                _vm._v("Проверка")
                              ])
                            ])
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { attrs: { id: "group-task-group", label: "Группа" } },
                    [
                      _c("task-group-select", {
                        attrs: { value: _vm.newItem.group_id },
                        on: { onSelect: _vm.onSelectTaskGroup }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-4" }, [
                    _c("h5", { staticClass: "summary-title mb-4" }, [
                      _vm._v("Информация")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-list" }, [
                      _c("div", { staticClass: "summary-item" }, [
                        _c("span", { staticClass: "summary-label" }, [
                          _vm._v("Объект:")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "summary-value" }, [
                          _vm._v(_vm._s(_vm.newItem.location_name || "—"))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "summary-item" }, [
                        _c("span", { staticClass: "summary-label" }, [
                          _vm._v("Адрес:")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "summary-value" }, [
                          _vm._v(_vm._s(_vm.newItem.start_address || "—"))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "summary-item" }, [
                        _c("span", { staticClass: "summary-label" }, [
                          _vm._v("Менеджер:")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "summary-value" }, [
                          _vm._v(_vm._s(_vm.newItem.executor_name || "—"))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "summary-item" }, [
                        _c("span", { staticClass: "summary-label" }, [
                          _vm._v("Руководитель:")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "summary-value" }, [
                          _vm._v(_vm._s(_vm.newItem.project_name || "—"))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "summary-item" }, [
                        _c("span", { staticClass: "summary-label" }, [
                          _vm._v("Вид работ:")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "summary-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.newItem.task_location_works.length
                                ? _vm.newItem.task_location_works[0]
                                    .work_type_name
                                : "—"
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "summary-item" },
                        [
                          _c("span", { staticClass: "summary-label" }, [
                            _vm._v("Исполнители:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "summary-value" },
                            [
                              _vm.newItem.task_workers.length > 25
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-primary cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.$bvModal.show(
                                              "modal-workers-list"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Список исполнителей\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.workerNames) +
                                        "\n                "
                                    )
                                  ]
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.newItem.task_workers.length
                            ? _c(
                                "b-badge",
                                { staticClass: "task-group-badge" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.newItem.task_workers.length) +
                                      " чел.\n              "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "summary-item" }, [
                        _c("span", { staticClass: "summary-label" }, [
                          _vm._v("Будет создано заявок:")
                        ]),
                        _vm._v(" "),
                        _vm.newTasksCount > 0
                          ? _c("span", { staticClass: "summary-value" }, [
                              _vm._v(_vm._s(_vm.newTasksCount))
                            ])
                          : _c("span", { staticClass: "summary-value" }, [
                              _vm._v("—")
                            ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "summary-item" }, [
                        _c("span", { staticClass: "summary-label" }, [
                          _vm._v("Даты новых заявок:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "summary-value" }, [
                          _vm.selectedTaskDates.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-wrap justify-content-end",
                                  staticStyle: { gap: "5px" }
                                },
                                _vm._l(_vm.selectedTaskDates, function(date) {
                                  return _c(
                                    "b-badge",
                                    {
                                      key: date,
                                      staticClass: "task-group-badge"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(date) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            : _c("span", [_vm._v("—")])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        id: "modal-workers-list",
                        title: "Список исполнителей",
                        "hide-footer": "",
                        scrollable: ""
                      }
                    },
                    _vm._l(_vm.newItem.task_workers, function(worker, idx) {
                      return _c(
                        "div",
                        {
                          key: worker.id || idx,
                          staticClass: "mb-2 pb-2 border-bottom"
                        },
                        [
                          _c("span", { staticClass: "text-muted mr-1" }, [
                            _vm._v(_vm._s(idx + 1) + ".")
                          ]),
                          _vm._v(" " + _vm._s(worker.name) + "\n          ")
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("workers-free", {
        ref: "workers_select",
        attrs: { workers: _vm.newItem.task_workers },
        on: { addToTask: _vm.onAddWorkers }
      }),
      _vm._v(" "),
      _vm.onboardingStep > 0 && _vm.showOnboarding
        ? _c("onboarding", {
            attrs: {
              step: _vm.onboardingStep,
              "steps-config": _vm.onboardingConfig
            },
            on: {
              next: _vm.handleNextStep,
              close: function($event) {
                _vm.onboardingStep = 0
              },
              disable: _vm.disableOnboarding
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-204b5b16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-204b5b16","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskGroupCreate.vue
// module id = null
// module chunks = 